module.exports = __webpack_public_path__ + "static/media/dark-accent.1be72675.svg";